import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import {
  Grid,
  Header,
  Divider,
  Segment,
  Button,
  Form,
  Message,
} from 'semantic-ui-react';

class ResetPassword extends React.Component {
  state = {
    email: '',
    admin_id: '',
    password: '',
    confirmed_password: '',
    code: this.props.match.params.code,
    codeValid: false,
    errorText: '',
    loading: false,
    reqResponse: null,
  }

  componentDidMount = () => {
    const { code } = this.state;
    // make sure code is valid, if not show error
    // and show resend link form
    axios.get(`/password-reset/${code}`)
      .then(res => {
        const { email, id } = res.data;
        this.setState({
          email,
          admin_id: id,
          codeValid: true,
        });
      })
      .catch(err => {
        this.setState({
          codeValid: false,
        });
      });
  }

  onInputChange = (e) => {
    this.setState({ reqResponse: null, [e.target.name]: e.target.value });
  }

  onResend = (evt) => {
    evt.preventDefault();
    const { email } = this.state;
    this.setState({ loading: true });

    axios.post('/generate-forgot-password-code/', { email })
      .then(res => {
        this.setState({
          loading: false,
          reqResponse: {
            success: true,
            header: 'Email Sent',
            content: `Instructions for resetting your password have been sent to ${email}.`
          }
        })
      })
      .then(() => {
        setTimeout(() => {
          document.location = '/dealer/';
        }, 3000)
      })
      .catch(err => {
        this.setState({
          loading: false,
          reqResponse: {
            success: false,
            header: 'There was a problem',
            content: err.response.data.ui_message,
          },
        })
      });
  }

  onSubmitPassword = (evt) => {
    evt.preventDefault();
    const { admin_id, password, confirmed_password } = this.state;
    this.setState({ loading: true });

    const formData = {
      dealer_admin_id: admin_id,
      password,
      confirmed_password,
    }

    axios.post('/password-reset/', formData)
      .then(res => this.setState({ loading: false }))
      .then(() => document.location = '/dealer/' )
      .catch(err => {
        this.setState({
          loading: false,
          reqResponse: {
            success: false,
            header: 'There was a problem',
            content: err.response.data.ui_message,
          },
        })
      });
  }

  render() {
    const {
      email,
      loading,
      password,
      confirmed_password,
      codeValid,
      reqResponse,
      errorText
    } = this.state;

    const buttonDisabled = password !== confirmed_password || password.length < 3 ? true : false;

    return (
      <Grid className="auth-grid" verticalAlign="middle" centered container columns={1}>
        <Grid.Column width={window.innerWidth <= 1024 ? 10 : 7}>
          <Segment padded color="blue">
            {
              codeValid
                ? (
                    <div>
                      <Header
                        textAlign="center"
                        content="Password Reset"
                        subheader={`Please submit a new password for the account: ${email}`}
                        size="large"
                      />
                      {
                        reqResponse &&
                          <Message
                            header={reqResponse.header}
                            icon={reqResponse.success ? 'check' : 'exclamation'}
                            positive={reqResponse.success ? true : false}
                            error={!reqResponse.success ? true : false}
                            content={reqResponse.content}
                          />
                      }
                      <Form onSubmit={this.onSubmitPassword} loading={loading}>
                        <Form.Input
                          onChange={this.onInputChange}
                          name="password"
                          value={password}
                          label="Password"
                          type="password"
                          placeholder="Password"
                          required />
                        <Form.Input
                          onChange={this.onInputChange}
                          name="confirmed_password"
                          value={confirmed_password}
                          label="Confirm Password"
                          type="password"
                          placeholder="Password, again"
                          required />
                        <Button
                          primary
                          fluid
                          content="Save New Password"
                          disabled={buttonDisabled}
                        />
                      </Form>
                    </div>
                  )
                : (
                    <div>
                      <Header
                        textAlign="center"
                        content="Password Reset"
                        subheader={`There was a problem with the forgot password code you clicked on. Get your link resent.`}
                        size="large"
                      />
                      {
                        reqResponse &&
                          <Message
                            header={reqResponse.header}
                            icon={reqResponse.success ? 'check' : 'exclamation'}
                            positive={reqResponse.success ? true : false}
                            error={!reqResponse.success ? true : false}
                            content={reqResponse.content}
                          />
                      }
                      <Form onSubmit={this.onResend} loading={loading}>
                        <Form.Input
                          name="email"
                          placeholder="Email"
                          label="Email"
                          value={email}
                          onChange={this.onInputChange}
                        />
                        <Button disabled={!email} primary fluid content="Submit" />
                      </Form>
                    </div>
                  )
            }
          </Segment>
        </Grid.Column>
      </Grid>
    );
  }
}

export default ResetPassword;
